import { useCallback, useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'

// utils
import {  getNFTEarned} from '../../sushi/utils'
import { userNFTMasterContract } from '../../userType/userNFTMasterContract'

// hooks
import useYam from '../bakery/useYam'
import useBlock from '../bakery/useBlock'
import { useActiveWeb3React } from '../'

const useAllNtfEarnings = (type?: string) => {
  const [balance, setBalance] = useState(new BigNumber(0))
  const { account } = useActiveWeb3React()
  const block = useBlock()
  const sushi = useYam()
  let dishMasterContract = userNFTMasterContract(sushi, type)

  const fetchBalance = useCallback(async () => {
    const balance = await getNFTEarned(dishMasterContract, account)
    setBalance(new BigNumber(balance).div(new BigNumber(10).pow(18)))
  }, [account, dishMasterContract])

  useEffect(() => {
    if (account && dishMasterContract && sushi) {
      fetchBalance()
    }
  }, [account, block, dishMasterContract, sushi, fetchBalance])

  return balance
}

export default useAllNtfEarnings